/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "gisteren",
        "-2": "eergisteren",
        "0": "vandaag",
        "1": "morgen",
        "2": "Oermorgen",
        "future": {
          "one": "Oer {0} dei",
          "other": "Oer {0} deien"
        },
        "past": {
          "one": "{0} dei lyn",
          "other": "{0} deien lyn"
        }
      },
      "day-narrow": {
        "-1": "gisteren",
        "-2": "eergisteren",
        "0": "vandaag",
        "1": "morgen",
        "2": "Oermorgen",
        "future": {
          "one": "Oer {0} dei",
          "other": "Oer {0} deien"
        },
        "past": {
          "one": "{0} dei lyn",
          "other": "{0} deien lyn"
        }
      },
      "day-short": {
        "-1": "gisteren",
        "-2": "eergisteren",
        "0": "vandaag",
        "1": "morgen",
        "2": "Oermorgen",
        "future": {
          "one": "Oer {0} dei",
          "other": "Oer {0} deien"
        },
        "past": {
          "one": "{0} dei lyn",
          "other": "{0} deien lyn"
        }
      },
      "hour": {
        "0": "this hour",
        "future": {
          "one": "Oer {0} oere",
          "other": "Oer {0} oere"
        },
        "past": {
          "one": "{0} oere lyn",
          "other": "{0} oere lyn"
        }
      },
      "hour-narrow": {
        "0": "this hour",
        "future": {
          "one": "Oer {0} oere",
          "other": "Oer {0} oere"
        },
        "past": {
          "one": "{0} oere lyn",
          "other": "{0} oere lyn"
        }
      },
      "hour-short": {
        "0": "this hour",
        "future": {
          "one": "Oer {0} oere",
          "other": "Oer {0} oere"
        },
        "past": {
          "one": "{0} oere lyn",
          "other": "{0} oere lyn"
        }
      },
      "minute": {
        "0": "this minute",
        "future": {
          "one": "Oer {0} minút",
          "other": "Oer {0} minuten"
        },
        "past": {
          "one": "{0} minút lyn",
          "other": "{0} minuten lyn"
        }
      },
      "minute-narrow": {
        "0": "this minute",
        "future": {
          "one": "Oer {0} minút",
          "other": "Oer {0} minuten"
        },
        "past": {
          "one": "{0} minút lyn",
          "other": "{0} minuten lyn"
        }
      },
      "minute-short": {
        "0": "this minute",
        "future": {
          "one": "Oer {0} minút",
          "other": "Oer {0} minuten"
        },
        "past": {
          "one": "{0} minút lyn",
          "other": "{0} minuten lyn"
        }
      },
      "month": {
        "-1": "foarige moanne",
        "0": "dizze moanne",
        "1": "folgjende moanne",
        "future": {
          "one": "Oer {0} moanne",
          "other": "Oer {0} moannen"
        },
        "past": {
          "one": "{0} moanne lyn",
          "other": "{0} moannen lyn"
        }
      },
      "month-narrow": {
        "-1": "foarige moanne",
        "0": "dizze moanne",
        "1": "folgjende moanne",
        "future": {
          "one": "Oer {0} moanne",
          "other": "Oer {0} moannen"
        },
        "past": {
          "one": "{0} moanne lyn",
          "other": "{0} moannen lyn"
        }
      },
      "month-short": {
        "-1": "foarige moanne",
        "0": "dizze moanne",
        "1": "folgjende moanne",
        "future": {
          "one": "Oer {0} moanne",
          "other": "Oer {0} moannen"
        },
        "past": {
          "one": "{0} moanne lyn",
          "other": "{0} moannen lyn"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "last quarter",
        "0": "this quarter",
        "1": "next quarter",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "nu",
        "future": {
          "one": "Oer {0} sekonde",
          "other": "Oer {0} sekonden"
        },
        "past": {
          "one": "{0} sekonde lyn",
          "other": "{0} sekonden lyn"
        }
      },
      "second-narrow": {
        "0": "nu",
        "future": {
          "one": "Oer {0} sekonde",
          "other": "Oer {0} sekonden"
        },
        "past": {
          "one": "{0} sekonde lyn",
          "other": "{0} sekonden lyn"
        }
      },
      "second-short": {
        "0": "nu",
        "future": {
          "one": "Oer {0} sekonde",
          "other": "Oer {0} sekonden"
        },
        "past": {
          "one": "{0} sekonde lyn",
          "other": "{0} sekonden lyn"
        }
      },
      "week": {
        "-1": "foarige wike",
        "0": "dizze wike",
        "1": "folgjende wike",
        "future": {
          "one": "Oer {0} wike",
          "other": "Oer {0} wiken"
        },
        "past": {
          "one": "{0} wike lyn",
          "other": "{0} wiken lyn"
        }
      },
      "week-narrow": {
        "-1": "foarige wike",
        "0": "dizze wike",
        "1": "folgjende wike",
        "future": {
          "one": "Oer {0} wike",
          "other": "Oer {0} wiken"
        },
        "past": {
          "one": "{0} wike lyn",
          "other": "{0} wiken lyn"
        }
      },
      "week-short": {
        "-1": "foarige wike",
        "0": "dizze wike",
        "1": "folgjende wike",
        "future": {
          "one": "Oer {0} wike",
          "other": "Oer {0} wiken"
        },
        "past": {
          "one": "{0} wike lyn",
          "other": "{0} wiken lyn"
        }
      },
      "year": {
        "-1": "foarich jier",
        "0": "dit jier",
        "1": "folgjend jier",
        "future": {
          "one": "Oer {0} jier",
          "other": "Oer {0} jier"
        },
        "past": {
          "one": "{0} jier lyn",
          "other": "{0} jier lyn"
        }
      },
      "year-narrow": {
        "-1": "foarich jier",
        "0": "dit jier",
        "1": "folgjend jier",
        "future": {
          "one": "Oer {0} jier",
          "other": "Oer {0} jier"
        },
        "past": {
          "one": "{0} jier lyn",
          "other": "{0} jier lyn"
        }
      },
      "year-short": {
        "-1": "foarich jier",
        "0": "dit jier",
        "1": "folgjend jier",
        "future": {
          "one": "Oer {0} jier",
          "other": "Oer {0} jier"
        },
        "past": {
          "one": "{0} jier lyn",
          "other": "{0} jier lyn"
        }
      }
    },
    "locale": "fy"
  });
}